export const InAppPurchaseEvents = {
  OpenedPurchaseModal: 'OpenedPurchaseModal',
  ClosedPurchaseModal: 'ClosedPurchaseModal',
};
